import React from 'react';
import './Switch.css';

function Switch({checked, checkedBackgroundColor, onChange}) {
    const toggle = () => {
        if (onChange) onChange(!checked);
    };

    const switchStyle = () => {
        return {
            background: checked ? (checkedBackgroundColor || '#005B80') : '#B0B0B0',
        };
    }

    return (
        <div className='switch' onClick={toggle} style={switchStyle()}>
            <div className={`switch-slider${checked ? ' checked' : ''}`}>
            </div>
        </div>
    );
}

export default Switch;